export const COLLAPSED = Object.freeze({ services: false, categories: false });
export const FILTER_RELOAD = "filters";

export function toggleSection(sections, section) {
  return { ...sections, [section]: !sections[section] };
}

export function sectionsAfterChange(sections, name) {
  return name === "service" ? { ...sections, services: false } : sections;
}

export function menuMaxHeight({ top, viewport, margin = 16, min = 240 }) {
  return Math.max(min, Math.floor(viewport - top - margin));
}

export function claimReopen(pending, reason) {
  if (!pending || reason !== FILTER_RELOAD) return { open: false, focusKey: null, sections: COLLAPSED };
  return { open: true, focusKey: pending.focusKey || null, sections: pending.sections || COLLAPSED };
}
